import { AuthorizedBaseAxios, flatten } from 'core/axios/axios';
import {
  CreateHigoDeviceDTO,
  DeviceModeType,
  HigoDeviceDto,
  HigoDeviceTokenDTO,
  mapToHigoDevice,
} from 'models/higoDevice';
import { evolve, map, pipe } from 'ramda';
import { PageParams, PageWrapperDTO } from 'models/page';

const devicesResUrl = `/api/management/devices`;

export interface DevicesFetchFilters {
  assigned?: boolean;
  serialNumber?: string;
}

export interface BusinessPartnerId {
  businessPartnerId: number;
}

export type DevicesFetchPageParams = PageParams & DevicesFetchFilters;

const fetch = (params: DevicesFetchPageParams) =>
  AuthorizedBaseAxios.get<PageWrapperDTO<HigoDeviceDto>>(`${devicesResUrl}`, {
    params,
  }).then(pipe(flatten, evolve({ content: map(mapToHigoDevice) })));

const deleteDevice = (deviceId: number) =>
  AuthorizedBaseAxios.delete(`${devicesResUrl}/${deviceId}`);

const registerNewDevice = (dto: CreateHigoDeviceDTO) =>
  AuthorizedBaseAxios.post<CreateHigoDeviceDTO>(`${devicesResUrl}`, dto);

const generateDeviceToken = (deviceId: number) =>
  AuthorizedBaseAxios.post<HigoDeviceDto>(`${devicesResUrl}/${deviceId}/token`);

const deleteDeviceToken = (deviceId: number) =>
  AuthorizedBaseAxios.delete(`${devicesResUrl}/${deviceId}/token`);

const getDeviceToken = (deviceId: number) =>
  AuthorizedBaseAxios.get<HigoDeviceTokenDTO>(
    `${devicesResUrl}/${deviceId}/token`
  ).then(flatten);

const generateDevicesTokens = ({
  businessPartnerId,
  subPartnersIds,
}: { subPartnersIds: string } & BusinessPartnerId) =>
  AuthorizedBaseAxios.post(
    `${devicesResUrl}/businessPartner/${businessPartnerId}/tokens?subPartnersIds=${subPartnersIds}`
  );

const getTokensCsvFile = (businessPartnerId: number) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  AuthorizedBaseAxios.get<any>(
    `${devicesResUrl}/businessPartner/${businessPartnerId}/csv`
  ).then(pipe(flatten));

const assignToPartner = (data: {
  businessPartnerId: number;
  deviceId: number;
  deviceModeType: DeviceModeType;
}) =>
  AuthorizedBaseAxios.post(
    `${devicesResUrl}/${data.deviceId}/businessPartner`,
    {
      partnerId: data.businessPartnerId,
      deviceModeType: data.deviceModeType,
    }
  );

const unassignPartner = (data: {
  businessPartnerId: number;
  deviceId: number;
}) =>
  AuthorizedBaseAxios.delete(
    `${devicesResUrl}/${data.deviceId}/businessPartner/${data.businessPartnerId}`
  );

export const DevicesAPI = {
  fetch,
  deleteDevice,
  assignToPartner,
  unassignPartner,
  registerNewDevice,
  generateDeviceToken,
  deleteDeviceToken,
  getDeviceToken,
  generateDevicesTokens,
  getTokensCsvFile,
};
